import { ProductManagement } from "@/components/ProductManagement";
import { useNavigate } from "react-router-dom";

export const ProductsPage = () => {
  const navigate = useNavigate();

  const handleBack = () => {
    navigate("/");
  };

  return <ProductManagement onBack={handleBack} />;
};
